import '@micro-zoe/micro-app/polyfill/jsx-custom-event'
import ReactDOM from 'react-dom/client'
// import App from './App.tsx';
import microApp from '@micro-zoe/micro-app'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import routes from '@/routes' // import App from './App'
import { combineRoutes } from './routerHelper.tsx'
import './index.css'
import './old-app-style-cover.less'
import { AliveScope } from 'react-activation'
import { setAppTitle } from '@/utils/common.ts'
import Login from '@/pages/login'

function isSafari() {
  const ua = navigator.userAgent;
  return /Safari/i.test(ua) && /AppleWebKit/i.test(ua) &&
    !/(Chrome|Chromium|Edg|OPR)/i.test(ua) &&
    /iPad|iPhone|iPod/.test(ua);
}

microApp.start({
  'router-mode': 'native',
  iframe: !isSafari(),
  // iframe: true,
  preFetchApps: [],
  excludeAssetFilter(assetUrl) {
    return (assetUrl || '').startsWith('https://svi.shj.cn/cdnstatic')
  },
})

// microApp.router.setBaseAppRouter()

const microApps = [
  /** 管理员设置 **/
  {
    appName: 'upms',
    devUrl: 'http://localhost:8100',
  },
  /** 供应链增值 **/
  {
    appName: 'scm',
    devUrl: 'http://localhost:6677',
  },
  // {
  //   appName: 'tams',
  //   devUrl: 'http://localhost:7210',
  // },
  {
    layout: 'workOrder',
    appName: 'flow',
    path: '*',
    devUrl: 'http://localhost:3500/flow/',
    // keepAlive: false,
  },
  {
    layout: 'root',
    appName: 'deal',
    devUrl: 'http://localhost:8300',
  },
  {
    appName: 'ofms',
    devUrl: 'http://localhost:7710/ofms/', //旧的财务系统（部分集成）
  },
  // {
  //   appName: 'fms',
  //   devUrl: 'http://localhost:7219', // 财务
  // },
  // {
  //   appName: 'marketing',
  //   devUrl: 'http://localhost:3200',
  // },
  // {
  //   appName: 'crm',
  //   devUrl: 'http://localhost:8095',
  // },
  {
    appName: 'npms', //新交付
    devUrl: 'http://localhost:6500',
  },
  {
    appName: 'pms', //新交付
    devUrl: 'http://localhost:6600',
  },
  {
    appName: 'data-screen', 
    devUrl: 'http://localhost:3000',
  },
  {
    appName: 'crm', //营销增值(智能派单)
    devUrl: 'http://localhost:6030',
  },
  {
    appName: 'mos', 
    devUrl: 'http://localhost:6030',
  },
  /** 二合一版本 供应商+材料等 **/
  {
    appName: 'smo',
    devUrl: 'http://localhost:6688',
  },
  {
    layout: 'root',
    appName: 'design', // 美学大师
    devUrl: 'http://localhost:9020',
  },
]

// 子应用 与 主应用路由组合
// export const router = createBrowserRouter(combineRoutes(microApps, routes))

export const router = createBrowserRouter([{ path: '*', element: <Login /> }])

microApp.router.setBaseAppRouter(router)

setAppTitle()

// eslint-disable-next-line react-refresh/only-export-components
function Main() {
  return (
    <AliveScope>
      <RouterProvider router={router} />
    </AliveScope>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Main />)
